export default __webpack_public_path__ + "static/media/ATRZip.fee6a30f.png";